(() => {
  angular
    .module('gm.common.directives')
    .directive('gmySupportLink', gmySupportLink);

  function gmySupportLink(
    Environment
  ) {
    'ngInject';

    const SUPPORT_LINK = Environment.urls.support.main;

    return {
      restrict: 'A',
      link(_scope, _element, attrs) {
        function onLinkChanged(newVal) {
          const destination = newVal || '';

          attrs.$set('href', `${SUPPORT_LINK}${destination}`);
          attrs.$set('target', '_blank');
        }

        attrs.$observe('gmySupportLink', onLinkChanged);
      },
    };
  }
})();
